
import { useEffect, useState } from 'react'
import url from '../api/url'
import { elToast } from '../functions/Alerta'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'

const useCuentaBancaria = () => {

    // variables
    const { URL } = url()
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const [usaCuentaBancaria, setUsaCuentaBancaria] = useState( 0 )
    const [cuenta, setCuenta] = useState( '' )
    const [cargando, setCargando] = useState( false )
    const [cargaPagina, setCargaPagina] = useState( false )
    const [mostrarGuardar, setMostrarGuardar] = useState(true)



    // funciones
    const guardar = () => {

        if ( !usaCuentaBancaria ) return
        if ( cuenta.trim().length === 0 ) {
            elToast( 'Debes indicar el número de cuenta', 'info' )
            return
        }

        setCargando( true )
        let aaa = { cuenta, funcion: 'guardarCuentaBancaria', correo: objLogueado.email }

        fetch( URL, {
            method: 'post',
            body: JSON.stringify( aaa )
        })
        .then( res => res.json() )
        .then( function (d) {
            if ( d.codigo === 1 ) {
                elToast( d.mensaje )
                setMostrarGuardar(false)
            } else {
                elToast( d.mensaje, 'error' )
            }
        })
        .catch( a => {
            elToast( "Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", "error" )
            // alert("")
        })
        .finally( () => setCargando( false ) )
    }

    const traerCuentaBancaria = () => {

        var fd = new FormData()
        fd.append("funcion", "traerCuentaBancaria")
        fd.append("email", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            if ( e.cuenta?.length > 0 ) {

                setUsaCuentaBancaria( true )
                setCuenta( e.cuenta )
                setMostrarGuardar(false)
            }
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la información de tu cuenta bancaria', 'error' );
        })
        .finally( () => setCargaPagina( true ) );
    }

    const eliminarCuentaBancaria = () => {

        var fd = new FormData()
        fd.append("funcion", "eliminarCuentaBancaria")
        fd.append("email", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            if ( e.codigo === 1 ) {
                elToast( e.mensaje )
                setCuenta('')
            } else {
                elToast( e.mensaje, 'error' )
            }
        })
        .catch( a => {
            elToast( 'Hay problemas al actualizar la información de tu cuenta bancaria', 'error' );
        })
    }



    // useEffect
    useEffect(() => {
        if ( cargaPagina && usaCuentaBancaria === false ) {
            eliminarCuentaBancaria()
        }
        if (usaCuentaBancaria === true) {
            setMostrarGuardar(true)
        }
        // eslint-disable-next-line
    }, [ usaCuentaBancaria ])

    useEffect(() => {
        traerCuentaBancaria()
        // eslint-disable-next-line
    }, [])




    return {
        usaCuentaBancaria, setUsaCuentaBancaria, cuenta, setCuenta, cargando, guardar,
        mostrarGuardar, setMostrarGuardar
    }
}

export default useCuentaBancaria
